import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ControlBase } from '../models/control-base';

@Injectable()
export class ControlService {
  constructor() { }

  toFormGroup(controls: ControlBase<string>[] ) {
    const group: any = {};

    controls.forEach(control => {
      group[control.key] = control.required ? new UntypedFormControl({value: control.value || '', disabled: control.disabled}, Validators.required)
                                              : new UntypedFormControl({value: control.value || '', disabled: control.disabled} || '');
    });
    return new UntypedFormGroup(group);
  }
}
